import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { TreeSelect } from 'design-system';
import type { TreeSelectProps } from 'antd';

import { toDepartmentTreeOptions } from 'src/utils/categoryTransform';

import { queryKeys } from 'src/constants/queryKeys';
import { getAllDepartment } from 'src/services/category';

import './styles.css';

export const departmentTreePopupProps: Pick<
  TreeSelectProps,
  'popupMatchSelectWidth' | 'classNames'
> = {
  popupMatchSelectWidth: false,
  classNames: { popup: { root: 'department-tree-select-popup' } },
};

type Props = Omit<TreeSelectProps, 'treeData'> & {
  options: { label: string; value: string | number }[];
  mode?: 'multiple';
};

export default function DepartmentTreeSelect({ options, mode, ...other }: Props) {
  const { data: departments = [] } = useQuery({
    queryKey: [queryKeys.getAllDepartment],
    queryFn: () => getAllDepartment(),
    staleTime: 1000 * 60 * 60,
  });

  const treeData = useMemo(() => {
    const ids = new Set(options.map((option) => String(option.value)));
    return toDepartmentTreeOptions(departments.filter((dept) => ids.has(dept.id)));
  }, [departments, options]);

  return (
    <TreeSelect
      showSearch
      treeNodeFilterProp="title"
      {...departmentTreePopupProps}
      multiple={mode === 'multiple'}
      treeData={treeData}
      {...other}
    />
  );
}
